import { inferHeadOfficeCityFromAddress } from './inferHeadOfficeCity';

/**
 * Defaults match the legacy static PDF footer image (Ace Relocations).
 * Used when a field is empty so documents still look professional.
 */
export const PDF_FOOTER_DEFAULTS = {
  addressBlock:
    '310, Arista Business Spaces, Opp. Stellar, Sidhu Bhavan Road, Off S G Highway, Ahmedabad - 380054.',
  supportPhone: 'Mob : 98252 19378, Ph : 9879519378',
  supportEmail: 'info@acerelocations.co.in',
  footerWebsite: 'www.acerelocations.co.in',
  footerTagline: 'Serving Pan India & Overseas',
  footerServicesText: [
    'House Hold Relocation - Domestic & International',
    'Office & Data Center Relocation',
    'Short & Long Term Storage',
    'Vehicle Relocation',
    'Antique, Fine Arts & High Value Item Relocation',
    "Trade Show & Mock - Up's",
  ].join('\n'),
};

export const PDF_HEADER_DEFAULTS = {
  headerTagline: 'We Make Moving Easy',
};

/**
 * Affiliation strapline on Customer / Truck copy (Serving Pan …).
 */
export function resolveAffiliationServingLine(branding = {}) {
  const b = branding || {};
  const explicit = typeof b.headOfficeCity === 'string' ? b.headOfficeCity.trim() : '';
  if (explicit) return `Serving Pan ${explicit}`;
  const inferred = inferHeadOfficeCityFromAddress(b.addressBlock);
  if (inferred) return `Serving Pan ${inferred}`;
  return 'Serving Pan India and Overseas';
}

/**
 * Logo for @react-pdf/renderer Image: remote URL, data URL, or fallback asset.
 */
export function pdfLogoSrcFromBranding(branding, fallbackSrc) {
  const url = branding && typeof branding.logoUrl === 'string' ? branding.logoUrl.trim() : '';
  if (url && (/^https?:\/\//i.test(url) || /^data:image\//i.test(url))) {
    return url;
  }
  return fallbackSrc;
}

/**
 * Authorised signatory image for @react-pdf/renderer: https URL, data URL, or bundled asset.
 */
export function pdfSignatureSrcFromBranding(branding, fallbackSrc) {
  const url = branding && typeof branding.signatureUrl === 'string' ? branding.signatureUrl.trim() : '';
  if (url && (/^https?:\/\//i.test(url) || /^data:image\//i.test(url))) {
    return url;
  }
  return fallbackSrc;
}

/**
 * @param {Record<string, unknown>} branding — from readTenantBranding() or tenant settings payload
 */
export function resolvePdfFooterFields(branding = {}) {
  const b = branding || {};
  const d = PDF_FOOTER_DEFAULTS;
  const trimOrDefault = (v, fallback) => {
    const s = v != null ? String(v).trim() : '';
    return s || fallback;
  };
  const servicesRaw = trimOrDefault(b.footerServicesText, d.footerServicesText);
  const serviceLines = servicesRaw
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  return {
    addressBlock: trimOrDefault(b.addressBlock, d.addressBlock),
    supportPhone: trimOrDefault(b.supportPhone, d.supportPhone),
    supportEmail: trimOrDefault(b.supportEmail, d.supportEmail),
    footerWebsite: trimOrDefault(b.footerWebsite, d.footerWebsite),
    footerTagline: trimOrDefault(b.footerTagline, d.footerTagline),
    serviceLines: serviceLines.length ? serviceLines : d.footerServicesText.split('\n'),
  };
}

/**
 * Letterhead right column: slogan, address + phone, email + website (same sources as footer).
 */
export function resolvePdfHeaderFields(branding = {}) {
  const base = resolvePdfFooterFields(branding);
  const b = branding || {};
  const trimOrDefault = (v, fallback) => {
    const s = v != null ? String(v).trim() : '';
    return s || fallback;
  };
  const headerTagline = trimOrDefault(b.headerTagline, PDF_HEADER_DEFAULTS.headerTagline);
  const addressOneLine = String(base.addressBlock || '')
    .replace(/\s*\n\s*/g, ', ')
    .replace(/\s+/g, ' ')
    .trim();

  return {
    ...base,
    headerTagline,
    addressOneLine,
  };
}
